function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClosedSign = function SvgClosedSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m4 6 3.1-3.7c1.5-1.8 4.3-1.8 5.8 0L16 6h4v12H0V6h4zm5.3-1.9c.4-.4 1.1-.4 1.5 0L12.3 6H7.7l1.6-1.9zm-.7 4.3c-.6-.5-1.6-.5-2.2 0-.5.6-.5 1.6 0 2.2L7.9 12l-1.4 1.4c-.6.6-.6 1.5 0 2.1.6.6 1.5.6 2.1 0l1.4-1.4 1.4 1.4c.6.6 1.5.6 2.1 0 .6-.6.6-1.5 0-2.1L12.1 12l1.4-1.4c.6-.6.6-1.5 0-2.1-.6-.6-1.5-.6-2.1 0L10 9.9 8.6 8.4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgClosedSign;